<template>
  <div class="OrderDetailTabContainer">
    <!-- 霊ごとの設定 -->
    <label class="FormGroup-Label">3. 没年月日</label>
    <div v-if="form.columns.length">
      <div class="Columns" v-for="(column, index) in form.columns" :key="index">
        <GridContainer style="line-height: 50px;" :column="4">
          <div class="subLabelAgeOfDeath">
            <label class="Columns-IndexLabel">{{ index + 1 }}霊目</label>
          </div>
          <div></div>
          <div></div>
          <div></div>
          <el-select
            placeholder="元号"
            :value="column._era"
            @change="onChangeEra($event, index)"
          >
            <el-option label="" value=""></el-option>
            <el-option
              v-for="item in eras"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            placeholder="年"
            :value="column._year"
            @change="onChangeYear($event, index)"
          >
            <el-option label="" value=""></el-option>
            <el-option
              v-for="item in years"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            placeholder="月"
            :value="$itaijiFM.getText(column.dateOfDeathMonth)"
            @change="onChangeMonth($event, index)"
          >
            <el-option label="" value=""></el-option>
            <el-option
              v-for="item in months"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-select
            placeholder="日"
            :value="$itaijiFM.getText(column.dateOfDeathDay)"
            @change="onChangeDay($event, index)"
          >
            <el-option label="" value=""></el-option>
            <el-option
              v-for="item in days"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </GridContainer>
        <div class="FormGroup u-mt10 u-ml50" v-if="false">
          <label class="FormGroup-Label">旧字を使用する</label>
          <div class="FormGroup-Form">
            <!-- 旧字を使用するどうか -->
            <ButtonGroup>
              <VisualButton
                v-for="item in includedOrNot"
                :key="item.value"
                :text="item.label"
                :isActive="
                  item.value === column.isOldCharacterForDateOfDeathNeeded
                "
                :variant="{ width: 'fit' }"
                @click="
                  _onClickIsOldCharacterForDateOfDeathNeeded(index, item.value)
                "
              />
            </ButtonGroup>
          </div>
        </div>

        <div
          class="FormGroup u-mt10 u-ml50"
          v-if="column.isOldCharacterForDateOfDeathNeeded"
        >
          <RestrictedCharacterInput
            label="旧字で年月日を入力"
            :value="column.oldCharacterForDateOfDeath"
            pattern="IHAI_INPUT_PATTERN"
            @onChangeInput="onChangeOldCharacterForDateOfDeath($event, index)"
            @onSubmit="onChangeOldCharacterForDateOfDeath($event, index)"
          />
        </div>
      </div>
    </div>
    <!-- 没表記 -->
    <div class="FormGroup">
      <div class="subLabelUnderCharacter">
        <label class="Columns-IndexLabel">没表記</label>
      </div>
      <div class="FormGroup-Form">
        <ButtonGroup>
          <el-select
            placeholder="選択"
            @change="_onClickIsDiedCharacterNeeded($event)"
            :value="form.isDiedCharacterNeeded"
          >
            <el-option
              v-for="option in addOrNot"
              :key="option.label"
              :label="option.label"
              :value="option.value"
            >
              {{ option.label }}</el-option
            >
          </el-select>
        </ButtonGroup>
        <!-- 没表記文字 -->
        <div class="FormGroup u-mt10 u-ml50" v-if="form.isDiedCharacterNeeded">
          <div class="FormGroup-Form" style="margin-top: -20px;">
            <el-select
              placeholder="選択"
              @change="_onChangeDiedCharacterOption($event)"
              :value="selectedDiedCharacterOption"
            >
              <el-option :value="''" label="未選択"></el-option>
              <el-option
                v-for="option in diedCharacters"
                :key="option.label"
                :label="option.label"
                :value="option.value"
              >
                {{ option.label }}</el-option
              >
            </el-select>
            <!-- 没表記 その他 -->
            <div class="u-ml50" v-if="selectedDiedCharacterOption === 'その他'">
              <div class="FormGroup-Form">
                <RestrictedCharacterInput
                  :value="$itaijiFM.getText(form.diedCharacter)"
                  pattern="IHAI_INPUT_PATTERN"
                  @onChangeInput="_onChangeDiedCharacterCard($event)"
                  @onSubmit="_onChangeDiedCharacterCard($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="u-line u-line--dashed" />
  </div>
</template>

<script>
import _ from "lodash";
import produce from "immer";
import { mapState, mapGetters } from "vuex";

import SAMPLE_URL from "../const/samplePictUrl.js";

// Data Handler
import EntityFactory from "@/entities/entity.factory";

// Components
import VisualButton from "@/components/VisualButton";
import ButtonGroup from "@/components/ButtonGroup";
import GridContainer from "@/components/GridContainer";
import RestrictedCharacterInput from "@/components/RestrictedCharacterInput";

// Usecases
import FileUsecase from "@/usecases/file.usecase";
import OrderFormUsecase from "@/usecases/orderForm.usecase";
import SanskritCharacterUsecase from "@/usecases/sanskritcharacter.usecase";

const orderOption = EntityFactory.create("orderOption");

const eras = ["昭和", "平成", "令和"];
const years = [
  "元年",
  "二年",
  "三年",
  "四年",
  "五年",
  "六年",
  "七年",
  "八年",
  "九年",
  "十年",
  "十一年",
  "十二年",
  "十三年",
  "十四年",
  "十五年",
  "十六年",
  "十七年",
  "十八年",
  "十九年",
  "二十年",
  "二十一年",
  "二十二年",
  "二十三年",
  "二十四年",
  "二十五年",
  "二十六年",
  "二十七年",
  "二十八年",
  "二十九年",
  "廿年",
  "廿一年",
  "廿二年",
  "廿三年",
  "廿四年",
  "廿五年",
  "廿六年",
  "廿七年",
  "廿八年",
  "廿九年",
  "三十年",
  "三十一年",
  "三十二年",
  "三十三年",
  "三十四年",
  "三十五年",
  "三十六年",
  "三十七年",
  "三十八年",
  "三十九年",
  "丗年",
  "丗一年",
  "丗二年",
  "丗三年",
  "丗四年",
  "丗五年",
  "丗六年",
  "丗七年",
  "丗八年",
  "丗九年",
  "四十年",
  "四十一年",
  "四十二年",
  "四十三年",
  "四十四年",
  "四十五年",
  "四十六年",
  "四十七年",
  "四十八年",
  "四十九年",
  "五十年",
  "五十一年",
  "五十二年",
  "五十三年",
  "五十四年",
  "五十五年",
  "五十六年",
  "五十七年",
  "五十八年",
  "五十九年",
  "六十年",
  "六十一年",
  "六十二年",
  "六十三年",
  "六十四年",
];

const months = [
  "一月",
  "二月",
  "三月",
  "四月",
  "五月",
  "六月",
  "七月",
  "八月",
  "九月",
  "十月",
  "十一月",
  "十二月",
];

const days = [
  "一日",
  "二日",
  "三日",
  "四日",
  "五日",
  "六日",
  "七日",
  "八日",
  "九日",
  "十日",
  "十一日",
  "十二日",
  "十三日",
  "十四日",
  "十五日",
  "十六日",
  "十七日",
  "十八日",
  "十九日",
  "廿日",
  "廿一日",
  "廿二日",
  "廿三日",
  "廿四日",
  "廿五日",
  "廿六日",
  "廿七日",
  "廿八日",
  "廿九日",
  "二十日",
  "二十一日",
  "二十二日",
  "二十三日",
  "二十四日",
  "二十五日",
  "二十六日",
  "二十七日",
  "二十八日",
  "二十九日",
  "三十日",
  "三十一日",
  "丗日",
  "丗一日",
];

export default {
  components: {
    VisualButton,
    ButtonGroup,
    GridContainer,
    RestrictedCharacterInput,
  },
  data () {
    return {
      sanskritCharacters: [],
      customSanskritCharacterBackUrlLocal: null,
      sanskritCharacterOrFamilyEmblemOptions: orderOption.sanskritCharacterOrFamilyEmblem,
      diedCharacters: [],
      selectedDiedCharacterOption: "",
      eras,
      years,
      yearsOfEra: [],
      months,
      days,
      currentReiwa: "",
      currentHeisei: "",
      addOrNot: orderOption.addOrNot,
      includedOrNot: orderOption.includedOrNot,
    };
  },
  computed: {
    ...mapState({
      orderType: state => state.orderForm.orderTypeInput,
    }),
    ...mapGetters({
      filteredFavoriteVariantCharacters: "orderForm/getFilteredFavoriteVariantCharacters",
    }),
    form: {
      get () {
        return _.cloneDeep(this.$store.state.orderForm.detailInput);
      },
      set (value) {
        this.$store.commit("orderForm/setDetail", { ...value });
      },
    },
  },
  watch: {},
  async created () {
    const charactersResult = await usecase.sanskritCharacter.getSanskritCharacters();
    this.sanskritCharacters = charactersResult.data.sanskritCharacters;
    await this.syncCustomSanskritCharacterBackUrlLocal();
    this.diedCharacters = await usecase.orderForm.getDiedCharacters();
    this.initDiedCharacter();
  },
  mounted () {
    // form getter は cloneDeep のため、分解結果をストアへ書き戻さないと
    // 元号・年のセレクトが未選択のままになる
    this.form = produce(this.form, draft => {
      draft.columns.forEach(column => {
        const eraAndYear = this.$itaijiFM.getText(column.dateOfDeathYear);
        if (!eraAndYear) {
          return;
        }
        for (const era of this.eras) {
          const result = eraAndYear.match(new RegExp(`^${era}(.*)`));
          if (result) {
            column._era = era;
            column._year = result[1];
            break;
          }
        }
        if (!column._era) {
          column._year = eraAndYear;
        }
      });
    });
  },
  updated () {
    this.commit();
  },
  methods: {
    async syncCustomSanskritCharacterBackUrlLocal () {
      const characterFilePath = this.form.customSanskritCharacterBackUrl;

      if (characterFilePath) {
        this.customSanskritCharacterBackUrlLocal = await usecase.file.fetchURL(characterFilePath);
        this.form.isSanskritCharacterBackNeeded = true;
        this.form.sanskritCharacterBack = {
          id: "uploadImg",
          sect: "ユーザー選択画像(裏梵字)",
          imageUrl: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, // constファイル作ってここに直打ち
          inputCode: "",
          imageUrlForTablet: SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER, // constファイル作ってここに直打ち
        };
      }
    },
    commit () {},
    initDiedCharacter () {
      this.selectedDiedCharacterOption = "";
      if (!this.form.diedCharacter || this.form.diedCharacter.length === 0) {
        return;
      }

      const selectedDiedCharacter = this.diedCharacters.find(
        diedCharacter =>
          diedCharacter.label ===
          this.$itaijiFM.getText(this.form.diedCharacter)
      );
      if (selectedDiedCharacter) {
        this.selectedDiedCharacterOption = selectedDiedCharacter.value;
      } else {
        this.selectedDiedCharacterOption = "その他";
      }
    },
    _onClickIsDiedCharacterNeeded (isNeeded) {
      if (!isNeeded) {
        this.selectedDiedCharacterOption = "";
        this.form.diedCharacter = [];
      }
      this.form = produce(this.form, d => {
        d.isDiedCharacterNeeded = isNeeded;
      });
    },
    _onChangeDiedCharacterOption (diedCharacterText) {
      this.selectedDiedCharacterOption = diedCharacterText;

      if (diedCharacterText !== "その他") {
        this.form = produce(this.form, d => {
          d.diedCharacter = this.$itaijiFM.toItaiji(diedCharacterText, this.filteredFavoriteVariantCharacters);
        });
      }
    },
    // diedCharacterを自由入力した際のアップデート
    _onChangeDiedCharacterCard (value) {
      const { toItaiji } = this.$itaijiFM;
      this.form = produce(this.form, d => {
        d.diedCharacter = toItaiji(value, this.filteredFavoriteVariantCharacters);
      });
    },
    _onClickIsOldCharacterForDateOfDeathNeeded (index, isYes) {
      const columns = [...this.form.columns];
      columns[index].isOldCharacterForDateOfDeathNeeded = isYes;
      if (!isYes) {
        // User doesn't want to use oldCharactger, so remove the existing input
        columns[index].oldCharacterForDateOfDeath = null;
      }
      this.form = { ...this.form, columns };
    },
    onChangeEra (event, index) {
      console.log("onChangeEra:");
      console.log(this.form.columns[index].dateOfDeathYear);
      const { toItaiji } = this.$itaijiFM;
      const year = this.form.columns[index]._year || "";
      this.form = produce(this.form, d => {
        d.columns[index]._era = event;
        d.columns[index].dateOfDeathYear = toItaiji(event + year, this.filteredFavoriteVariantCharacters);
      });
    },
    onChangeYear (event, index) {
      console.log("onChangeYear:");
      console.log(this.form.columns[index].dateOfDeathYear);
      const { toItaiji } = this.$itaijiFM;
      const era = this.form.columns[index]._era || "";
      this.form = produce(this.form, d => {
        d.columns[index]._year = event;
        d.columns[index].dateOfDeathYear = toItaiji(era + event, this.filteredFavoriteVariantCharacters);
      });
    },
    onChangeMonth (event, index) {
      const { toItaiji } = this.$itaijiFM;
      this.form = produce(this.form, d => {
        d.columns[index].dateOfDeathMonth = toItaiji(event, this.filteredFavoriteVariantCharacters);
      });
    },
    onChangeDay (event, index) {
      const { toItaiji } = this.$itaijiFM;
      this.form = produce(this.form, d => {
        d.columns[index].dateOfDeathDay = toItaiji(event, this.filteredFavoriteVariantCharacters);
      });
    },
    onChangeOldCharacterForDateOfDeath (event, index) {
      const columns = [...this.form.columns];
      columns[index].oldCharacterForDateOfDeath = event;
      this.form = { ...this.form, columns };
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
    usecase.orderForm = new OrderFormUsecase();
    usecase.sanskritCharacter = new SanskritCharacterUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

.el-select-dropdown__item.selected {
  color: unset !important;
}
</style>
>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.OrderDetailTabContainer > * + * {
  margin-top: 10px;
}
// .Date-Of-Death-Input {
// }
// .subLabelAgeOfDeath {
// }
.subLabelUnderCharacter {
  margin-right: 4%;
}
</style>
